<template>
	<div></div>
</template>

<script>
import { useAccessRightsStore } from '../stores/accessRights/accessRights.ts'
import { useSelectedPlanStore } from '@/stores/plans/selectedPlan.ts'
import { retrievePatientData } from '@/composables/patientData.comp.js'

export default {
	name: 'Five9ChatWidget',
	data() {
		return {
			options: {
				appId: 'abcbs',
				description: '2025-04-22 Update',
				domain: 'abcbs',
				campaignName: 'CHATBOT - Member claim status TEST',
				title: 'CHATBOT - Member claim status<br>Live Chat',
				showEndButton: true,
				minimizeOnEnd: true,
				endConfirmation: true,
				titleBackgroundColor: '#015987',
				welcomeBubbleColor: '#e9f1f8',
				agentBubbleColor: '#f5f5f5',
				customerBubbleColor: '#015987',
				templateButtonColor: '#2475b7',
				templateButtonHoverColor: '#16466e',
				buttonBackgroundColor: '#2475b7',
				miniForm: true,
				contact: {
					email: ''
				},
				attributes: [
					{
						'Salesforce.firstName': ''
					},
					{
						'Salesforce.lastName': ''
					},
					{
						'Salesforce.memberid': ''
					},
					{
						dateOfBirth: ''
					}
				],
				formData: [
					{
						type: 'text',
						formType: 'form',
						required: false,
						label: 'Preferred Name',
						cav: 'contact.name',
						pos: '',
						value: ''
					}
				],
				addCloseChat: true,
				alwaysShowEnd: true,
				timezone: 'America/Chicago',
				font: false,
				fontSize: false,
				fontChat: 'Roboto,Arial,sans-serif',
				fontForm: 'Roboto,Arial,sans-serif',
				fontFormInput: 'Roboto,Arial,sans-serif',
				fontMenu: 'Roboto,Arial,sans-serif',
				fontTitle: 'Roboto,Arial,sans-serif',
				fontTemplate: 'Roboto,Arial,sans-serif',
				fontSizeTemplate: '14',
				miniSubmitColorCompleted: '#000000',
				miniSubmitBackgroundColorCompleted: '#ffffff',
				fontMenuSize: false
			},
			selectedPlan: null
		}
	},
	mounted() {
		//Initiate process
		this.updateOptions()
		this.selectedPlan = useSelectedPlanStore().getStore()
		this.gainAccess()
	},
	methods: {
		updateOptions() {
			this.options.campaignName =
				import.meta.env.VITE_CHAT_CAMPAIGN ?? 'CHATBOT - Member claim status'
			this.options.styleSheets = [
				'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
				`${window.location.origin}/five9Styles.css`
			]
		},
		chatCallback(event) {
			try {
				switch (event.type) {
					case 'accepted':
						document.querySelector('body').classList.add('chat_started')
						break
					case 'endClicked':
						break
					case 'endConfirmation':
						break
					case 'endChatConfirmed':
						break
					case 'endChatCancelled':
						break
					case 'terminate':
						window.dispatchEvent(chatEnded)
						document.querySelector('body').classList.remove('chat_started')
						break
					default:
						break
				}
			} catch (exception) {
				console.error('Exception caught in event handler: ' + exception.stack)
			}
		},
		async patientInformation() {
			await retrievePatientData().then((res) => {
				const firstNameAttr = 'Salesforce.firstName'
				const lastNameAttr = 'Salesforce.lastName'
				const fullNameAttr = 'name'
				const memberidAttr = 'Salesforce.memberid'
				const dateOfBirthAttr = 'dateOfBirth'
				// const emailAttr = 'email'
				setTimeout(() => {
					// const fullNameIndex = this.options.attributes.findIndex(
					// 	(el) => el[fullNameAttr] != undefined
					// )
					const firstNameIndex = this.options.attributes.findIndex(
						(el) => el[firstNameAttr] != undefined
					)
					const lastNameIndex = this.options.attributes.findIndex(
						(el) => el[lastNameAttr] != undefined
					)
					// const emailIndex = this.options.attributes.findIndex((el) => el[emailAttr] != undefined)
					const dobIndex = this.options.attributes.findIndex(
						(el) => el[dateOfBirthAttr] != undefined
					)
					const salesForceIndex = this.options.attributes.findIndex(
						(el) => el[memberidAttr] != undefined
					)

					const { name, birthDate, telecom } = res.state[this.selectedPlan.memberId]
					const email = telecom.filter((tele) => tele.system === 'email')[0].value

					// this.options.attributes[fullNameIndex][fullNameAttr] = name[0].text
					this.options.attributes[firstNameIndex][firstNameAttr] = name[0].given[0]
					this.options.attributes[lastNameIndex][lastNameAttr] = name[0].family
					this.options.contact.email = email
					this.options.attributes[dobIndex][dateOfBirthAttr] = birthDate
					this.options.attributes[salesForceIndex][memberidAttr] = this.selectedPlan.memberId
					return
				}, 10)
			})
		},
		async gainAccess() {
			//Get current access rights
			await useAccessRightsStore()
				.loadStore()
				.then(async (res) => {
					if (res.chatType === 'Five9') {
						await this.patientInformation()
						return true
					} else {
						return false
					}
				})
				.then((showChat) => {
					if (showChat) {
						this.options.callback = this.chatCallback
						Five9ChatPlugin(this.options)
					}
				})
		}
	}
}
</script>
